import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService } from '@crosscutting/public_api';
import { environment } from '@env/environment';
import { Hersteller } from '@models/woonglashersteller';

@Injectable()
export class WoonglasschadeherstellersService {
  constructor(private _http: HttpService) { }

  getSchadeherstellers(): Observable<Hersteller[]> {
    return this._http.get<Hersteller[]>(environment.ophalenWoonglasschadeherstellersUrl);
  }
}
